/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./roundLoading.vue?vue&type=template&id=9ff42fd4&scoped=true"
import script from "./roundLoading.vue?vue&type=script&lang=js"
export * from "./roundLoading.vue?vue&type=script&lang=js"
import style0 from "./roundLoading.vue?vue&type=style&index=0&id=9ff42fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff42fd4",
  null
  
)

export default component.exports